export default function Modal({ open, onClose, children, width = 480 }) {
  if (!open) return null;

  return (
    <div onClick={onClose} className="ec-modal-overlay">
      <div onClick={(e) => e.stopPropagation()} className="ec-modal-content" style={{ width }}>
        {children}
      </div>
    </div>
  );
}
